.header {
  padding: var(--mantine-spacing-md) var(--mantine-spacing-lg);
  border-bottom: 1px solid var(--mantine-color-gray-3);
}

/* Mantine Drawer content defaults to height:100% + overflow-y:auto, which would
   let the header + body overflow and scroll the whole panel. Make it a
   non-scrolling flex column so the header stays pinned and the body grid
   scrolls on its own. (Mirrors FreightBookingWizard.) */
.drawerContent {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-width: 1480px;
  margin: 0 auto;
}

.drawerBodySlot {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 0;
}

/* Mantine's Drawer title slot sizes to its content by default, which collapses
   the title bar to the title's width and parks the close button beside it.
   Stretch the slot to fill the header so the inner Group's space-between can
   push the actions/close to the right edge. */
.titleSlot {
  flex: 1;
  min-width: 0;
}

/* The header slot renders the full-width title bar; stretch its child Group. */
.titleBar {
  flex: 1;
  min-width: 0;
}

.titleText {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.statusHeader {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--mantine-spacing-sm);
  padding: var(--mantine-spacing-md) var(--mantine-spacing-lg);
  border-bottom: 1px solid var(--mantine-color-gray-3);
  background: var(--mantine-color-gray-0);
}

/* Two-column body grid (3fr 2fr, matching the old view); scrolls on overflow. */
.bodyGrid {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: var(--mantine-spacing-xl);
  padding: var(--mantine-spacing-lg);
}

.column {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-md);
}
